import { lazy } from 'react';

export const BrandList = lazy(() => import('./brand/BrandList'));
export const AddBrand = lazy(() => import('./brand/AddBrand'));
export const UpdateBrand = lazy(() => import('./brand/UpdateBrand'));
export const ColorList = lazy(() => import('./color/ColorList'));
export const AddColor = lazy(() => import('./color/AddColor'));
export const UpdateColor = lazy(() => import('./color/UpdateColor'));
export const CustomerCategoryPricingList = lazy(() => import('./customer_category_pricing/CustomerCategoryPricingList'));
export const UpdateCustomerCategoryPricing = lazy(() => import('./customer_category_pricing/UpdateCustomerCategoryPricing'));
export const CustomerPricingList = lazy(() => import('./customer_pricing/CustomerPricingList'));
export const UpdateCustomerPricing = lazy(() => import('./customer_pricing/UpdateCustomerPricing'));
export const DeliveryNoteList = lazy(() => import('./delivery_note/DeliveryNoteList'));
export const GenerateDeliveryNote = lazy(() => import('./delivery_note/GenerateDeliveryNote'));
export const InvoiceList = lazy(() => import('./invoice/InvoiceList'));
export const AddInvoice = lazy(() => import('./invoice/AddInvoice'));
export const ItemList = lazy(() => import('./item/ItemList'));
export const AddItem = lazy(() => import('./item/AddItem'));
export const UpdateItem = lazy(() => import('./item/UpdateItem'));
export const MeasureUnitList = lazy(() => import('./measure_unit/MeasureUnitList'));
export const AddMeasureUnit = lazy(() => import('./measure_unit/AddMeasureUnit'));
export const UpdateMeasureUnit = lazy(() => import('./measure_unit/UpdateMeasureUnit'));
export const MeasureUnitTypeList = lazy(() => import('./measure_unit_type/MeasureUnitTypeList'));
export const AddMeasureUnitType = lazy(() => import('./measure_unit_type/AddMeasureUnitType'));
export const UpdateMeasureUnitType = lazy(() => import('./measure_unit_type/UpdateMeasureUnitType'));
export const PaymentList = lazy(() => import('./payment/PaymentList'));
export const AddPayment = lazy(() => import('./payment/AddPayment'));
export const ProductPricingList = lazy(() => import('./product_pricing/ProductPricingList'));
export const UpdateProductPricing = lazy(() => import('./product_pricing/UpdateProductPricing'));
export const RackList = lazy(() => import('./rack/RackList'));
export const AddRack = lazy(() => import('./rack/AddRack'));
export const UpdateRack = lazy(() => import('./rack/UpdateRack'));
export const SegmentList = lazy(() => import('./segment/SegmentList'));
export const AddSegment = lazy(() => import('./segment/AddSegment'));
export const UpdateSegment = lazy(() => import('./segment/UpdateSegment'));
export const SubCategoryList = lazy(() => import('./sub_category/SubCategoryList'));
export const AddSubCategory = lazy(() => import('./sub_category/AddSubCategory'));
export const UpdateSubCategory = lazy(() => import('./sub_category/UpdateSubCategory'));
export const StockReject = lazy(() => import('./stock_reject/StockReject'));